import { Component, EventEmitter, Output, inject, input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MenuItem } from '@coin/admin/core/util';
import { TinyHelpers } from '@coin/shared/core/util-helpers';
import { ViewInformationDialogComponent } from '../view-information/parts/view-information-dialog/view-information-dialog.component';

@Component({
  selector: 'admin-app-card',
  templateUrl: './app-card.component.html',
  styleUrls: ['./app-card.component.scss'],
  standalone: false
})
export class AppCardComponent {
  private matDialog = inject(MatDialog);

  readonly menuItem = input<MenuItem>(undefined);
  readonly type = input<'primary' | 'secondary'>('primary');
  readonly translationPrefix = input<string>(undefined);
  readonly showMoreInfoButton = input(false);

  @Output() openClicked: EventEmitter<MenuItem> = new EventEmitter<MenuItem>();

  public get isPrimary(): boolean {
    return this.type() === 'primary';
  }

  public camelCaseToKebabCase = TinyHelpers.camelCaseToKebabCase;

  public openInformationDialog(item: MenuItem): void {
    this.matDialog.open(ViewInformationDialogComponent, {
      width: '50vw',
      maxWidth: '2000px',
      data: { translationPrefix: `${this.translationPrefix()}${this.camelCaseToKebabCase(item.name)}.` }
    });
  }

  public isTruncated(element: HTMLElement): boolean {
    return element?.offsetWidth < element?.scrollWidth || element?.offsetHeight < element?.scrollHeight;
  }
}
